import { useState, useEffect } from "react";

function RSVPStats(props) {
    const [stats, setStats] = useState({});
    const [pageLoading, setPageLoading] = useState(true);
    const [loadingError, setLoadingError] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    async function fetchData() {
        try {
            const res = await fetch(
                `https://wedding-website-backend-nu.vercel.app/api/stats`
            );

            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }

            const data = await res.json();
            setStats(data);
        } catch (err) {
            console.error(err);
            setLoadingError(true);
        } finally {
            setPageLoading(false);
        }
    }

    const {
        totalInvitees,
        notYetRSVPed,

        attendingWedding,
        notAttendingWedding,
        adultsAttendingWedding,
        teensAttendingWedding,
        childrenAttendingWedding,
        toddlersAttendingWedding,

        attendingWelcomeParty,
        notAttendingWelcomeParty,
        adultsAttendingWelcomeParty,
        teensAttendingWelcomeParty,
        childrenAttendingWelcomeParty,
        toddlersAttendingWelcomeParty,

        beefEntrees,
        fishEntrees,
        vegetarianEntrees,
        childrenEntrees,

        badEntreeData,
        badAgeData
    } = stats;

    const statCards = [
        {
            title: "RSVP Summary",
            items: [
                { label: "Total Invitees", value: totalInvitees },
                { label: "Already RSVPed", value: totalInvitees - notYetRSVPed },
                { label: "Not Yet RSVPed", value: notYetRSVPed },
            ],
        },
        {
            title: "Event Attendance",
            items: [
                { label: "Attending Wedding", value: attendingWedding },
                { label: "Not Attending Wedding", value: notAttendingWedding },
                { label: "Attending Welcome Party", value: attendingWelcomeParty },
                { label: "Not Attending Welcome Party", value: notAttendingWelcomeParty },
            ],
        },
        {
            title: "Entrée Selection",
            items: [
                { label: "Beef", value: beefEntrees },
                { label: "Fish", value: fishEntrees },
                { label: "Vegetarian", value: vegetarianEntrees },
                { label: "Children's Meal", value: childrenEntrees },
            ],
        },
        {
            title: "Malformed Data",
            items: [
                { label: "Invalid Entrées", value: badEntreeData },
                { label: "Invalid Age Groups", value: badAgeData },
            ],
        },
        {
            title: "Adults (above 21)",
            items: [
                { label: "Attending Wedding", value: adultsAttendingWedding },
                { label: "Attending Welcome Party", value: adultsAttendingWelcomeParty },
            ],
        },
        {
            title: "Teens (below 21)",
            items: [
                { label: "Attending Wedding", value: teensAttendingWedding },
                { label: "Attending Welcome Party", value: teensAttendingWelcomeParty },
            ],
        },
        {
            title: "Children",
            items: [
                { label: "Attending Wedding", value: childrenAttendingWedding },
                { label: "Attending Welcome Party", value: childrenAttendingWelcomeParty },
            ],
        },
        {
            title: "Toddlers",
            items: [
                { label: "Attending Wedding", value: toddlersAttendingWedding },
                { label: "Attending Welcome Party", value: toddlersAttendingWelcomeParty },
            ],
        },
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 p-6">
            {pageLoading && <p>Loading...</p>}
            {loadingError && <p className="text-red-400">Failed to fetch RSVP Stats</p>}
            {!pageLoading && !loadingError && (
                <>
                    {statCards.map((section, i) => (
                        <div
                            key={i}
                            className="rounded-md shadow-sm border border-gray-200 bg-white"
                        >
                            <div className="p-4">
                                <h2 className="text-lg font-bold mb-4">{section.title}</h2>
                                <ul className="space-y-2">
                                    {section.items.map((item, idx) => (
                                        <li
                                            key={idx}
                                            className="flex justify-between text-sm pb-1 border-b last:border-b-0"
                                        >
                                            <span>{item.label}</span>
                                            <span className="font-semibold">{item.value}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
}

export default RSVPStats;